<app-navigation-bar></app-navigation-bar>
<app-spinner></app-spinner>
<router-outlet></router-outlet>


